/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Breakdown_Kind_Early_Bird_DiscountInputs */

const en_price_breakdown_kind_early_bird_discount = /** @type {(inputs: Price_Breakdown_Kind_Early_Bird_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Early-bird discount`)
};

/**
* | output |
* | --- |
* | "Early-bird discount" |
*
* @param {Price_Breakdown_Kind_Early_Bird_DiscountInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const price_breakdown_kind_early_bird_discount = /** @type {((inputs?: Price_Breakdown_Kind_Early_Bird_DiscountInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Breakdown_Kind_Early_Bird_DiscountInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_price_breakdown_kind_early_bird_discount(inputs)
});